<template>
    <div>
        <van-form @submit="onSubmit">
            <van-field
                v-model="nickname"
                name="nickname"
                label="昵称"
                placeholder="昵称"
                :rules="[{ required: true, message: '请填写昵称' }]"
            />
            <van-field
                v-model="phone_number"
                name="phone_number"
                label="手机号码"
                placeholder="手机号码"
                :rules="[{ required: true, message: '请填写手机号码' }]"
            />
            <van-field name="sex_type" label="单选框">
                <template #input>
                    <van-radio-group v-model="sex_type" direction="horizontal">
                        <van-radio :name="0">保密</van-radio>
                        <van-radio :name="1">男</van-radio>
                        <van-radio :name="2">女</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field
                readonly
                clickable
                name="birthday"
                :value="birthday"
                label="生日"
                placeholder="点击选择时间"
                @click="showPicker = true"
                :rules="[{ required: true, message: '请选择生日' }]"
                />
            <van-popup v-model="showPicker" position="bottom">
                <van-datetime-picker
                    type="date"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @confirm="onConfirm"
                    @cancel="showPicker = false"
                    v-model="birthDayDateTime"
                />
            </van-popup>
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">提交</van-button>
            </div>
        </van-form>
        <Loading v-if="isLoading"/>
    </div>
</template>
<script>
import { Toast } from 'vant'
import { DateObjectToDateTime } from '@/utils/auth'
import { updateUserInfo, getCouponsList, showCouponsFlag } from '../api/index.js'
import Loading from '../components/loaddingCom'
export default {
    components: { Loading },
    data() {
        return {
            nickname: '',
            phone_number: '',
            sex_type: 0,
            birthday: '',
            birthDayDateTime: new Date(),
            showPicker: false,
            minDate: new Date(1930, 1, 1),
            maxDate: new Date(),
            hasCoupons: false,
            showGetCoupons: false,
            isLoading: false
        };
    },
    mounted() {
        let userInfo = JSON.parse(window.localStorage.getItem('user'))
        this.nickname = userInfo.nickname
        this.phone_number = userInfo.phone_number
        this.sex_type = userInfo.sex_type || 0
        this.birthday = userInfo.birthday
        this.getcouponsList(0)
        this.showCouponsFlag()
        console.log('userInfo', userInfo)
    },
    methods: {
        showCouponsFlag() {
            showCouponsFlag().then(res => {
                console.log('showCouponsFlag', res)
                if(res.data == 1) {
                    this.showGetCoupons = true
                }
            })
        },
        getcouponsList(e) {
            let data = {
                page: 1,
                page_size: 100,
                use_flag: e
            }
            getCouponsList(data).then(res => {
                console.log('getcouponsList=======>', res)
                if (res.message == 'success') {
                    let list = res.data.data || []
                    this.hasCoupons = list.length
                }
            })
        },
        onSubmit(values) {
            console.log('submit', values);
            this.isLoading = true
            updateUserInfo(values).then(res => {
                console.log(res)
                this.isLoading = false
                if (res.message == 'success') {
                    window.localStorage.setItem('user', JSON.stringify(res.data))
                    Toast.success('修改成功');
                    setTimeout(() => {
                        if (this.hasCoupons || !this.showGetCoupons) {
                            this.$router.replace({ path: '/userCenter' })
                        } else {
                            this.$router.replace({ path: '/getCoupons' })
                        }
                    }, 1000)
                }
            }).catch(() => {
                this.isLoading = false
            })
        },
        onConfirm(value) {
            this.birthday = DateObjectToDateTime(value);
            this.showPicker = false;
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
